import React, { FC, useState } from 'react';

import { v4 as uuidv4 } from 'uuid';

import ResponsiveListingSearchGuest from '@components/views/hotel/listing/components/ResponsiveSearch/ResponsiveListingSearchGuest';
import { validateGuestsChildrenAges } from '@components/views/hotel/utils';
import { validRoomChildAge } from '@utils/dateUtil';
import {
  KidInterface,
  ListingSearchRoomInterface,
} from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import useSearchBar from '@contexts/searchbar';
import { HotelSearchBarActionType } from '@contexts/searchbar/types/hotel';

import { IHotelSearchGuest } from './HotelSearchGuest';

const MobileSearchGuest: FC<IHotelSearchGuest> = ({ onChange, value }) => {
  const {
    state: { hotel: state },
    dispatch,
  } = useSearchBar();

  const rooms = value || state.rooms;

  const [hotelRoomsList, setHotelRoomsList] = useState(rooms);
  const [isShowSearchListingGuest, setIsSHowSearchListingGuest] =
    useState(false);

  const clearRoomsValues = (): void => {
    dispatch({
      type: HotelSearchBarActionType.SET_ROOMS,
      payload: hotelRoomsList,
    });
  };

  /**
   * Custom functions to handle the show mobile guest modal
   */
  const handleShowMobileGuestModal = () => {
    clearRoomsValues();
    setIsSHowSearchListingGuest(true);
  };

  /**
   * Custom functions to control the children error
   * using this function we can find an invalid child age and update te error property
   */
  const handleChildError = (): void => {
    dispatch({
      type: HotelSearchBarActionType.SET_ROOMS,
      payload: rooms.map((room) =>
        room.childrenList.length !== 0
          ? {
              ...room,
              childrenList:
                room.childrenList &&
                room.childrenList.map((kid: KidInterface) =>
                  validRoomChildAge(String(kid.age))
                    ? { ...kid, error: false }
                    : { ...kid, error: true }
                ),
            }
          : room
      ),
    });
  };

  /**
   * Custom functions to handle the close mobile guest modal
   */
  const handleHideMobileGuestModal = () => {
    if (validateGuestsChildrenAges(rooms)) {
      handleChildError();
    } else {
      setIsSHowSearchListingGuest(false);
    }
  };

  const handleUpdateFinalRooms = (
    rooms: Array<ListingSearchRoomInterface>
  ): void => {
    setHotelRoomsList(rooms);
  };

  /**
   * Custom functions to control the rooms
   * using this function we can add new room
   */
  const addRoom = (currentRooms: Array<ListingSearchRoomInterface>): void => {
    const newRooms = [
      ...currentRooms,
      {
        id: uuidv4(),
        adultCount: 2,
        childrenList: [],
        title: `${currentRooms.length + 1}. Oda`,
        closable: true,
        error: false,
        key: String(
          currentRooms.length > 0
            ? Number(currentRooms[currentRooms.length - 1].key) + 1
            : 1
        ),
        ref: React.createRef<HTMLDivElement>(),
      },
    ];

    if (onChange) {
      onChange(newRooms);
    } else {
      dispatch({
        type: HotelSearchBarActionType.SET_ROOMS,
        payload: newRooms,
      });
    }
  };

  return (
    <ResponsiveListingSearchGuest
      width='100%'
      height='100%'
      placement='top'
      open={isShowSearchListingGuest}
      showGuestModal={handleShowMobileGuestModal}
      hideGuestModal={handleHideMobileGuestModal}
      rooms={rooms}
      onHotelRoomsUpdate={(hr) =>
        onChange
          ? onChange(hr)
          : dispatch({
              type: HotelSearchBarActionType.SET_ROOMS,
              payload: hr,
            })
      }
      finialRooms={hotelRoomsList}
      handleUpdateFinalRooms={handleUpdateFinalRooms}
      handleChildError={handleChildError}
      addNewRoom={() => addRoom(rooms)}
    />
  );
};

export default MobileSearchGuest;
